import React from 'react';
import { MdErrorOutline, MdCheckCircleOutline, MdInfoOutline, MdClose } from 'react-icons/md';
import useToast from '../../hooks/useToast';
import { ToastContainer, ToastItem, ToastMessage, ToastClose } from './styled';

const iconMap = {
  error: MdErrorOutline,
  success: MdCheckCircleOutline,
  info: MdInfoOutline,
};

const Toast = () => {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <ToastContainer>
      {toasts.map(toast => {
        const Icon = iconMap[toast.type] || iconMap.info;
        return (
          <ToastItem key={toast.id} type={toast.type} role="alert">
            <Icon size={20} />
            <ToastMessage>{toast.message}</ToastMessage>
            <ToastClose onClick={() => removeToast(toast.id)} aria-label="Fechar notificação">
              <MdClose size={18} />
            </ToastClose>
          </ToastItem>
        );
      })}
    </ToastContainer>
  );
};

export default Toast;
